<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  beforeCreate(){
    this.$loading.show()
  },
  mounted() {
    let token = localStorage.getItem('token')
    if(!token||token==''){
      this.$router.push('login')
    }
    this.$loading.hide()
  },
}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>
